import React from 'react';

const ProductTab = ({product, styleName}) => {
    const maxLength = 85;
    const {image, title, note} = product;
    let {description} = product;
    description = description.length > maxLength ? description.substring(0, maxLength) + ' ...' : description;

    if (!styleName) {
        styleName = "col-sm-6 col-12 mb-4";
    }
    return (
        <div className={`${styleName}`}>
            <div className="row">
                <div className="col-lg-5 col-md-4 col-6 mb-2">
                    <img style={{height: 110, objectFit: 'cover'}} className="img-fluid rounded" src={image}
                         alt={title}/>
                </div>
                <div className="col-lg-7 col-md-8 col-6">
                    <h4 className="mb-3 text-secondary"> {title}</h4>
                    <h5 style={{minHeight: 50}} className="mb-2 text-justify">{description}</h5>
                    <div className="d-flex align-items-end">
                        <h6 className='text-primary'>{note}</h6>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ProductTab;




// WEBPACK FOOTER //
// ./components/toliton/desktop/products/productTab.js